class ActionBarService {
    constructor(){
        this.actions = [];
        this.pageTitle = '';
        this.isVisible = true;
        this.isBackButtonVisible = false;
    }

    resetState(){
        this.actions = [];
        this.pageTitle = '';
        this.isVisible = true;
        this.isBackButtonVisible = false;
    }
    
    registerActions(newActions) {
        if(!Array.isArray(newActions)){
            throw new Error('Actions must be an Array');
        }

        this.actions = newActions.filter(action => this.isValidAction(action));
    }

    registerTitle(title){
        this.pageTitle = title || '';
    }

    setAction(index, action){
        if(this.isValidAction(action) && this.actions[index]){
            this.actions[index] = action;
        }
    }

    isValidAction(action){
        return !!(action.label && action.onClick && action.hasOwnProperty('enabled'));
    }

    setVisibility(toggle){
        this.isVisible = !!toggle; //convert to boolean
    }

    setBackButtonVisibility(show) {
        this.isBackButtonVisible = show;
    }
}

angular.module('MW.Influencers.ActionBarService', [])
.service('ActionBarService', [ActionBarService]);